// EmptyState (009 T036): what a screen shows when a list has nothing (no stories, no alerts), with an optional
// action.
import type { ReactNode } from 'react';

/** Props of {@link EmptyState}. */
export interface EmptyStateProps {
  title: ReactNode;
  body?: ReactNode;
  icon?: ReactNode;
  action?: ReactNode;
}

/**
 * An empty state.
 * @param props title, body, icon and action
 * @returns the block
 */
export function EmptyState({ title, body, icon, action }: EmptyStateProps) {
  return (
    <section className="flex w-full flex-col items-center gap-related px-4 py-4 text-center">
      {icon}
      <h2 className="font-display text-xl font-bold text-black">{title}</h2>
      {body ? <p className="text-sm text-ink-secondary">{body}</p> : null}
      {action}
    </section>
  );
}
